<div class="header-container">
    <div class="logo-container">
        <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
            <nb-icon icon="menu-2-outline"></nb-icon>
        </a>
        <a class="logo" (click)="navigateHome()"><img src="../../../../assets/images/logo wide.svg" width="50%"></a>
    </div>
    <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
        <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
    </nb-select> -->
    <nb-select status="secondary" [selected]='override.currentLang'>
        <nb-option (click)="override.switchLanguage('ar')" [value]="'ar'"> {{ 'عربي' }}</nb-option>
        <nb-option (click)="override.switchLanguage('en')" [value]="'en'"> {{ 'En' }}</nb-option>
    </nb-select>
</div>

<div class="header-container">
    <nb-actions size="small">
        <nb-action class="control-item">
            <nb-search type="modal-half" placeholder="{{'Global Search ...' |translate}}" hint="{{'Hit enter to search' |translate}}"></nb-search>
        </nb-action>
        <!-- <nb-action class="control-item" icon="email-outline"></nb-action> -->
        <!-- <nb-action class="control-item" icon="bell-outline"></nb-action> -->
        <nb-action class="user-action" *nbIsGranted="['view', 'user']">
            <nb-user [nbContextMenu]="userMenu" [onlyPicture]="userPictureOnly" [name]="user?.email">
            </nb-user>
        </nb-action>
    </nb-actions>
</div>